module.exports = __webpack_public_path__ + "img/15.d0918369.png";